import { iconRequest, iconSearch } from '../defaultValues';

const data = {
    role_e8b5c3f8cfe4485ea903e3da766c4de0: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
    ],
};
export default data;
